import {
	RESET_STATE,
	SET_AUTOPARK_INFO,
	SET_IS_AUTOPARK_INFO_LOADING,
	SET_AUTOPARK_COMPANIES_LIST,
	SET_IS_AUTOPARK_COMPANIES_LIST_LOADING,
	SET_IS_AUTOPARK_CREATING,
	SET_IS_AUTOPARK_UPDATING,
	SET_IS_AUTOPARK_DELETING,
} from './actions';

export const initialState = {
	isAutoparkInfoLoading: false,
	autoparkInfo: null,
	autoparkCompaniesList: [],
	isAutoparkCompaniesListLoading: false,
	isAutoparkCreating: false,
	isAutoparkUpdating: false,
	isAutoparkDeleting: false,
};

const autoparkModalReducer = (state = initialState, action) => {
	const { type, payload } = action;
	switch (type) {
		case SET_AUTOPARK_INFO:
			return {
				...state,
				autoparkInfo: payload,
			};
		case SET_IS_AUTOPARK_INFO_LOADING:
			return {
				...state,
				isAutoparkInfoLoading: payload,
			};
		case SET_AUTOPARK_COMPANIES_LIST:
			return {
				...state,
				autoparkCompaniesList: payload,
			};
		case SET_IS_AUTOPARK_COMPANIES_LIST_LOADING:
			return {
				...state,
				isAutoparkCompaniesListLoading: payload,
			};
		case SET_IS_AUTOPARK_CREATING:
			return {
				...state,
				isAutoparkCreating: payload,
			};
		case SET_IS_AUTOPARK_UPDATING:
			return {
				...state,
				isAutoparkUpdating: payload,
			};
		case SET_IS_AUTOPARK_DELETING:
			return {
				...state,
				isAutoparkDeleting: payload,
			};
		case RESET_STATE:
			return initialState;
		default:
			return state;
	}
};

export default autoparkModalReducer;
